import { ReferralType } from '~/types/referral';
import type { SpecialtyFormConfig } from '~/types/specialty';
import { DentalSpecialty } from '~/types/specialty';

/**
 * Configuration for Oral Surgery specialty referral form
 */
export const oralSurgeryConfig: SpecialtyFormConfig = {
  specialty: DentalSpecialty.ORAL_SURGERY,
  displayName: 'Oral Surgery',
  requiresToothSelection: true,
  referralTypes: [
    ReferralType.URGENT,
    ReferralType.ROUTINE,
    ReferralType.SYMPTOMATIC,
    ReferralType.ELECTIVE,
    ReferralType.CONSULTATION,
  ],
  diagnosisOptions: [],
};
